<template>
  <div>
<!--    <pageTop></pageTop>-->

    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">

        <video
            class="video"
            preload="auto"
            muted
            loop
            playsinline
            autoplay
            src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"
            tabindex="-1"
        ></video>

      </div>
      <h1 class="banner-title">

        <p  class="text">专注直播，奔赴热爱</p>
        <div :class="isMobile()?'subTitle-mobile':'subTitle'" >JOIN EAST·DB</div>
      </h1>
      <div class="search">
        <img  @click="searchJobs" src="@/assets/images/toudi.png" >
      </div>
      <div class="arrow-down" @click="scrollDown()"></div>
      <div style="margin-top: 2px" class="arrow-down" @click="scrollDown()"></div>

    </div>
    <div class="row">
      <div class="col-md-3">
        <img src="@/assets/images/bg1.png">
      </div>
    <!-- 产品 -->
    <section class="col-md-6 w3l-bottom-grids-6 py-5 " id="bottom">
      <div style="margin-bottom: -80px">
        <div v-if="isMobile" class="top_menu_04" style="font-size: 20px">
          We get live streams, we get you better.
        </div>
        <div v-else class="top_menu_04">
          We get live streams, we get you better.
        </div>
        <div class="top_menu_05" style="margin-top: 30px;margin-bottom: 100px;">
          懂直播，更懂你
        </div>
      </div>
      <div v-if="isMobile()" style="margin-top: 10px">
<!--      <hr style="height: 1px; border: none; border-top: 5px solid #C69500;width: 30px;" />-->
      <div :class="isMobile()?'top_menu_40-mobile':'top_menu_40'" >
        ABOUT EAST·DB
      </div>
      <div :class="isMobile()?'top_menu_04-mobile':'top_menu_04'" style="margin-top: -44px;">
        关于东方地保
      </div>
      </div>

      <div v-else style="margin-top: 160px">
        <!--      <hr style="height: 1px; border: none; border-top: 5px solid #C69500;width: 30px;" />-->
        <div class="top_menu_40">
          ABOUT EAST·DB
        </div>
        <div class="top_menu_04" style="margin-top: -44px;">
          关于东方地保
        </div>
      </div>
    </section>

      <div class="col-md-3">
        <img src="@/assets/images/bg2.png">
      </div>
  </div>
<!--    <div class="product-list__8moPK col-md-11">-->
<!--      <img src="@/assets/images/29.png" style="max-width: 93%;height: auto;">-->

<!--    </div>-->




    <div class="row">
      <div class="col-md-3">
      </div>


      <div class="col-md-6 box-shadow">
        <div style="margin: 30px;">
          <p class="home_p">2018年,东方地保(EAST DB)正式进军泛娱乐直播领域,并以卓越的成绩崭露头角。在该领域的首次尝试中,我们一举荣膺多个官方平台奖项,并在 2020 年第一季度成功实现营收突破千万元。 </p>
          <p class="home_p">经过近两年的深耕细作和经验积累，我们于2021年对基地进行整体迁移，迁移至年轻人的潮流中心集美区万科云城,并深化多元化布局战略,业务除主营的泛娱乐直播运营外,还包含 MCN、本地生活团购、本地生活服务、社区电商、物流业务、健身房业务等,拥有独立的办公楼近 10000平方米，致力于为客户提供完善的配套设施和出
            色运营能力。</p>
          <p class="home_p">
            通过不断的沉淀与发展,我们不仅与抖音、快手、微信视频号等平台达成了长期战略合作,还吸纳了来自全国各地(含港、澳、台)的近万名主播,包括金牌主播、超级大V和全国现象级红人,拥有全网2亿粉丝总量的庞大社群，一跃成为厦门甚至福建省规模最大的互联网直播基地之一。
          </p>
          <p class="home_p">
            我们深信,我们的创新和专业知识,以及优质的客户服务,将帮助我们在未来取得更大的成功,并为广大用户带来更加丰富多彩的直播体验。
          </p>
        </div>

        <div class="col-md-3">
        </div>
      </div>
    </div>


    <div class="block-box bfc mb86">
      <section class="w3l-bottom-grids-6 py-5 " id="bottom">

        <!--      <hr style="height: 1px; border: none; border-top: 5px solid #C69500;width: 30px;" />-->
        <div class="top_menu_40">
          BUSINESS AND SERVICES
        </div>
        <div :class="isMobile()?'top_menu_04-mobile':'top_menu_04'" style="margin-top: -24px;">
          业务与服务
        </div>

      </section>



      <div class="row">
        <div class="col-md-3">
        </div>

        <div class="col-md-6 box-shadow">
          <div class="row" style="margin: 50px;" >
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/21.png" style="width: 80px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/22.png" style="width: 120px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/23.png" style="width: 80px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/24.png" style="width: 90px;"></a>
            </div>
          </div>



          <div  class="row" style="margin: 50px;">
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/25.png" style="width: 80px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/26.png" style="width: 80px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/27.png" style="width: 80px;"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/28.png" style="width: 80px;"></a>
            </div>
          </div>

        </div>


        <div class="col-md-3">
        </div>

      </div>


      <section class="w3l-bottom-grids-6 py-5">
        <div class="top_menu_04">
          <img src="@/assets/images/10.png" style="width: 100px;  margin-top: 50px;">
        </div>

        <div class="top_menu_04">
          <img src="@/assets/images/live_bg.jpg" style="width: 2500px;">
        </div>
      </section>
      <section class="w3l-bottom-grids-6 py-5 " id="bottom">

        <!--      <hr style="height: 1px; border: none; border-top: 5px solid #C69500;width: 30px;" />-->
        <div class="top_menu_40">
          EXPLORE INTERESTS
        </div>
        <div :class="isMobile()?'top_menu_04-mobile':'top_menu_04'" style="margin-top: -24px;">
          探索你感兴趣的职位
        </div>

      </section>




      <div class="row" style="margin-top: 50px;">
        <div class="col-md-3">
        </div>
        <div class="col-md-6 box-shadow">
          <div class="row" :style="{ margin: marginWidth }">
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/13.png":style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/14.png" :style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/15.png" :style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/lm.png" :style="{ width: navWidth }"></a>
            </div>
          </div>


          <div class="row" :style="{ margin: marginWidth }">
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/17.png" :style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/18.png" :style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/19.png" :style="{ width: navWidth }"></a>
            </div>
            <div class="col-md-3" style="text-align: center;">
              <a ><img src="@/assets/images/hz.png" :style="{ width: navWidth }"></a>
            </div>
          </div>
        </div>


        <div class="col-md-3">
        </div>

      </div>
      <div class="content-grid">


      </div>
    </div>


    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";


// import home from '@/api/home'

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      marginWidth: this.isMobile()?'10px':'50px', // 初始颜色为透明
      navWidth: this.isMobile()?'40px':'80px', // 初始颜色为透明
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: []
    };
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },

  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>
.text {
  font-weight: bold;
  line-height: 0.1; /* 设置行高为字体大小的1.5倍 */
  letter-spacing: 0.3em; /* 使用em单位，相对于字体大小设置间距 */
  font-family: 'Arial', sans-serif; /* 使用Arial字体，如果没有则使用系统默认无衬线字体 */
}
50%
.home_p{
  font-family: "等线";
  font-size: 16px; /* 设置基础字体大小为16像素，提升可读性 */
  line-height: 1.6; /* 设置较为舒适的行间距，1.6是一个常见且易读的选择 */
  color: #333; /* 使用深灰色作为正文颜色，比纯黑更柔和 */
  text-align: justify; /* 文本两端对齐，使段落看起来更整齐（如果需要的话，有时左对齐也是很好的选择） */
  margin: 0 auto; /* 如果希望整体内容居中，可以设置外边距为自动，这里假设body有固定宽度或max-width */
  max-width: 800px; /* 限制内容最大宽度，提升阅读体验，特别是在宽屏设备上 */
  padding: 10px; /* 添加内边距，使内容与边界有一定的呼吸空间 */
}
.subTitle {
  margin-top: 10px;
}
.subTitle-mobile{
  margin-top: 10px;
  position: relative;
  font-size: 14px;
  letter-spacing: 10px;
}
.video{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}
.text_mobile{
  font-size: 30px;
  margin-bottom: 50px;
}
/deep/ .el-drawer__header {
  /* scoped 下需要使用 /deep/ 或 >>> 来穿透样式 */
  background-color: #FFFFFF;
  font-size: 30px;
  color: #333333;
  font-weight: bold;
}

/deep/ .el-drawer__title {
  color: #333333;
  font-size: 18px;
}
</style>
